import React from 'react';
import { fade, makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import { Typography } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@material-ui/core/Menu';
import MenuIcon from '@material-ui/icons/Menu';
import Button from '@mui/material/Button';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    fontWeight: 900,
    [theme.breakpoints.up('sm')]: {
      display: 'block',
      textAlign: 'center',
    },
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  subMenuItem: {
    paddingLeft: theme.spacing(4), // indent under "About us"
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
}));

export default function PrimarySearchAppBar() {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [aboutAnchorEl, setAboutAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const [currentPage, setCurrentPage] = React.useState('home');

  const isMenuOpen = Boolean(anchorEl);
  const isAboutMenuOpen = Boolean(aboutAnchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const history = useHistory();

  function handleNavigate(page) {
    if (page === 'ABOUT US') {
      history.push('/about-us');
      setCurrentPage('about-us');
    }
    if (page === 'CHARITABLE CAUSES') {
      history.push('/charitable-causes');
      setCurrentPage('charitable-causes');
    }
    if (page === 'CONTACT') {
      history.push('/contact');
      setCurrentPage('contact');
    }
    if (page === 'PASTORAL TEAM') {
      history.push('/pastoral-team');
      setCurrentPage('pastoral-team');
    }
  }

  // Close the mobile menu (no navigation here)
  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  // Click on a mobile menu item that should navigate
  const handleMobileMenuItemClick = (page) => {
    setMobileMoreAnchorEl(null);
    handleNavigate(page);
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleAboutMenuOpen = (event) => {
    setAboutAnchorEl(event.currentTarget);
  };

  const handleAboutMenuClose = () => {
    setAboutAnchorEl(null);
  };

  const menuId = 'primary-search-account-menu';
  const mobileMenuId = 'primary-search-account-menu-mobile';
  const aboutMenuId = 'about-menu';

  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
      <MenuItem onClick={handleMenuClose}>My account</MenuItem>
    </Menu>
  );

  const renderAboutMenu = (
    <Menu
      id={aboutMenuId}
      anchorEl={aboutAnchorEl}
      keepMounted
      open={isAboutMenuOpen}
      onClose={handleAboutMenuClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <MenuItem
        onClick={() => {
          handleAboutMenuClose();
          handleNavigate('ABOUT US');
        }}
      >
        ABOUT US
      </MenuItem>
      <MenuItem
        onClick={() => {
          handleAboutMenuClose();
          handleNavigate('PASTORAL TEAM');
        }}
      >
        PASTORAL TEAM
      </MenuItem>
    </Menu>
  );

  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      {/* About us */}
      <MenuItem onClick={() => handleMobileMenuItemClick('ABOUT US')}>
        About Us
      </MenuItem>

      {/* Pastoral Team visually "under" About us */}
      <MenuItem
        className={classes.subMenuItem}
        onClick={() => handleMobileMenuItemClick('PASTORAL TEAM')}
      >
         - Pastoral Team
      </MenuItem>

      <MenuItem onClick={() => handleMobileMenuItemClick('CHARITABLE CAUSES')}>
        Charitable Causes
      </MenuItem>

      <MenuItem onClick={() => handleMobileMenuItemClick('CONTACT')}>
        Contact
      </MenuItem>
    </Menu>
  );


  return (
    <div className={classes.grow}>
      <AppBar
        position="fixed"
        elevation={0}
        style={{
          background: '#486c8e',
          color: '#ffffff',
        }}
      >
        <Toolbar>
          <Typography
            onClick={() => history.push('/')}
            style={{ cursor: 'pointer', fontSize: '30px', fontFamily: 'Source Sans 3' }}
            className={classes.title}
            variant="h6"
            noWrap
          >
            Leeds Brethren In Christ Church
          </Typography>
          <div className={classes.grow} />
          <div className={classes.sectionDesktop}>
            <Button
              aria-controls={aboutMenuId}
              aria-haspopup="true"
              onClick={handleAboutMenuOpen}
              className={
                currentPage === 'about-us' || currentPage === 'pastoral-team'
                  ? 'active-menu'
                  : 'default-menu'
              }
            >
              ABOUT US
            </Button>
            <Button
              className={
                currentPage === 'charitable-causes' ? 'active-menu' : 'default-menu'
              }
              onClick={() => handleNavigate('CHARITABLE CAUSES')}
            >
              CHARITABLE CAUSES
            </Button>
            <Button
              className={currentPage === 'contact' ? 'active-menu' : 'default-menu'}
              onClick={() => handleNavigate('CONTACT')}
            >
              CONTACT
            </Button>
          </div>
          <div className={classes.sectionMobile}>
            <IconButton
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
      {renderAboutMenu}
    </div>
  );
}
